var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("LayoutAuth", [
    _c(
      "form",
      {
        staticClass: "form form--auth",
        attrs: { novalidate: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.onSubmit.apply(null, arguments)
          },
        },
      },
      [
        _c("ValidationAlert", {
          attrs: { errorList: _vm.errors.collect("server") },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "form__group" }, [
          _c(
            "label",
            { staticClass: "form__label", attrs: { for: "username" } },
            [_vm._v("Email Address")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.username,
                expression: "formData.username",
              },
              { name: "validate", rawName: "v-validate" },
            ],
            staticClass: "form__control",
            attrs: {
              id: "username",
              type: "text",
              name: "username",
              placeholder: "Enter your email address here",
              required: "",
              autocomplete: "username",
              autofocus: "",
            },
            domProps: { value: _vm.formData.username },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "username", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form__group" },
          [
            _c(
              "label",
              { staticClass: "form__label", attrs: { for: "password" } },
              [_vm._v("Password")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.password,
                  expression: "formData.password",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: "password",
                type: "password",
                name: "password",
                placeholder: "Enter your password here",
                required: "",
                autocomplete: "current-password",
              },
              domProps: { value: _vm.formData.password },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "password", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "forgot",
                attrs: { to: "/login/forgot-password" },
              },
              [_c("span", [_vm._v("Forgot password")])]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form__group form__group--submit" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--primary",
              attrs: { type: "submit", disabled: _vm.$wait.is("login") },
            },
            [_vm._v("Login")]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }